module.exports = __webpack_public_path__ + "static/media/Template_27.e687c494.png";